import React from "react";
import {CheckCircle} from "@material-ui/icons";
import {Grid} from "material-ui";

import {ItemGrid, RegularCard, Table} from "components";
import {store, oktaSignIn} from "../../index";
import {getCurrentOrders} from "../../service/liveTrackingActions";
import moment from "moment"
import momentDurationFormatSetup from "moment-duration-format"
import {Timer} from "./timer"
import {connect} from "react-redux";
export class LiveTrackingPage extends React.Component {

    componentDidMount() {
        this.loadLiveTrackingData();
        this.interval = setInterval(this.loadLiveTrackingData, 30000);
    }

    render() {
        return (
            <Grid container>
                <ItemGrid xs={12} sm={12} md={12}>
                    <RegularCard
                        cardTitle="Current Orders"
                        cardSubtitle="All ongoing orders and concluded orders in last hour"
                        content={
                            <Table
                                tableHeaderColor="primary"
                                tableHead={["Email", "ParentCartId", "PONumber", "SapCartId", "Status", "SapOrder#", "S3", "Timestamp", "Latest State", "Time Waiting"]}
                                tableData={this.getCurrentOrderData()}
                            />
                        }
                    />
                </ItemGrid>
            </Grid>
        );
    }


    componentWillUnmount() {
        clearInterval(this.interval);
    }

    loadLiveTrackingData = () => {
        console.log("Calling live tracking. location.pathname: " + window.location.pathname)
        store.dispatch(getCurrentOrders(oktaSignIn.tokenManager.get('access_token').accessToken));
    }

    stateSortOrder = ["PLACED", 'SUBMITTED', 'ENGAGED', 'CONFIRMED'];
    statusSortOrder = ["PROCESSED", 'FAILED'];

    getLastestState(line) {
        if (!line.sapCartId) {
            return "PLACED";
        } else if (!line.status) {
            return "SUBMITTED";
        } else if (!line.s3) {
            return "ENGAGED";
        } else {
            return "CONFIRMED";
        }
    }

    getTimestamp(line, state) {
        switch (state) {
            case "PLACED":
                return line.placedAt;
            case "SUBMITTED" :
                return line.submittedAt;
            case "ENGAGED" :
                return line.processedAt;
            case "CONFIRMED" :
                return line.confirmedAt;
            default:
                return new Date().getTime();

        }
    }

    getCurrentOrderData() {
        momentDurationFormatSetup(moment);
        var array = []
        let checkStyle = {
            textAlign: "center",
            width: "100px"
        }
        if (this.props.liveTrackingData.map) {
            this.props.liveTrackingData.map((line) => {
                let lastestState = this.getLastestState(line);
                let timeDiff = new Date() - new Date(this.getTimestamp(line, lastestState));

                array.push([
                    line.email,
                    line.parentCartId.toString(),
                    line.poNumber.toString(),
                    line.sapCartId ? line.sapCartId : "-",
                    line.status ? line.status : "-",
                    line.saporderNum ? line.saporderNum : "-",
                    typeof line.s3 !== "undefined" ? line.s3.toString() : "-",
                    moment(this.getTimestamp(line, lastestState)).format("YYYY-MM-DD hh:mm A"),
                    lastestState,
                    line.status === "Failed" ?  <CheckCircle style={{color: "red", ...checkStyle}}/> :
                        (line.s3? <CheckCircle style={{
                            color: this.getColor(line.s3), ...checkStyle
                            // boxShadow: "0 12px 20px -10px rgba(156, 39, 176, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(156, 39, 176, 0.2)"
                        }}/> : <Timer time={timeDiff}></Timer>)
                ])
            })
        }

        array.sort((a, b) => {
            let stateVal = this.stateSortOrder.indexOf(a[8]) - this.stateSortOrder.indexOf(b[8]);
            let statusVal = this.statusSortOrder.indexOf(a[4].toUpperCase()) - this.statusSortOrder.indexOf(b[4].toUpperCase());
            return stateVal !== 0 ? stateVal :
                (statusVal != 0 ? statusVal : (a[7].localeCompare(b[7])))
        });

        return array
    }

    getColor(s3) {
        if(s3.toLowerCase() === "true")
            return "green";
        else
            return "red";
    }
}

const mapStateToProps = state => {
    return {
        liveTrackingData: state.liveTrackingState.liveTrackingData,
        accessToken: state.authState.accessToken
    }
};

const LiveTracking = connect(
    mapStateToProps
)(LiveTrackingPage);


export default LiveTracking;



// WEBPACK FOOTER //
// ./src/views/TableList/LiveTracking.jsx